module.exports = "/_next/static/videos/mainvisual-video-L-62e507838df196cc3609d0dc119b608e.mp4";